import React from "react";
import { useProductDispatch, useProductSelector } from "../../../stores/product/product.store";
import { ProductState } from "../../../stores/product/product-state.interface";
import { Wishlist } from "../../../svg/Wishlist";
import { changeWishlistStatus } from "../../../stores/product/product.reducer";

export const WishlistButton: React.FC = () => {
    const status = useProductSelector((state: ProductState) => state.product.isWishlist);
    const dispatch = useProductDispatch();

    const change = (value: boolean) => {
        dispatch(changeWishlistStatus(value));
    }

    return (
        <>
            <Wishlist enable={ status } onChange={ change }/>
        </>
    )
}